export class LocationCollection {
  id: any;
  name: String;
  created_at: String;
  updated_at: String;

  constructor() {
    const keys = ['id', 'name', 'created_at'];
    keys.forEach((key) => this[key] = null);
  }

  setData(locationCollectionData) {
    const data = locationCollectionData.location_collections;
    Object.keys(data).map((item) => {
      this[item] = data[item];
    });
  }
}
